import { FT_SINGLE } from '../FilterTypes';
import { CAT_CONSUMABLE_VARIATIONS } from 'App/utils/Collections';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
};

export default {
  category: CAT_CONSUMABLE_VARIATIONS,
  filters: [
    {
      id: 'id',
      label: 'ID Number',
      type: FT_SINGLE,
      group: groups.general,
      hint: '',
    },
  ],
};
